import { Button, EmptyState } from "pixelize-design-library";
import { describeError } from "@core/api";

export type ErrorStateProps = {
  error: unknown;
  title?: string;
  onRetry?: () => void;
};

export const ErrorState = ({
  error,
  title = "This page could not load",
  onRetry,
}: ErrorStateProps) => (
  <EmptyState
    title={title}
    description={describeError(error)}
    colorScheme="error"
    variant="subtle"
    action={onRetry ? <Button label="Try again" variant="outline" onClick={onRetry} /> : undefined}
  />
);
